import { render, staticRenderFns } from "./AudioPlayerPlaylist.vue?vue&type=template&id=35f15c16&scoped=true&"
import script from "./AudioPlayerPlaylist.vue?vue&type=script&lang=ts&"
export * from "./AudioPlayerPlaylist.vue?vue&type=script&lang=ts&"
import style0 from "./AudioPlayerPlaylist.vue?vue&type=style&index=0&id=35f15c16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f15c16",
  null
  
)

export default component.exports